import React from "react";
import { useAppSelector } from "@store/hooks";
import AddressUtils from "@utils/address";

const getAddressString = async (setAddressString: React.Dispatch<React.SetStateAction<string>>) => {
    const addressString = await AddressUtils.getProblemInformationAddressString();
    setAddressString(addressString ?? "");
    if (addressString === null) {
        setTimeout(() => {
            getAddressString(setAddressString);
        }, 100);
    }
}

// create hook useAddressString
export const useAddressString = () => {
    const propertyAddressesLength = useAppSelector(({ temp }) => temp.PropertyAddressAddressesLength)
    const [addressString, setAddressString] = React.useState<string>("");

    // useEffect to set addressString
    React.useEffect(() => {
        if (propertyAddressesLength > 0) {
            getAddressString(setAddressString);
        }
        else {
            setAddressString("");
        }
    }, [propertyAddressesLength]);

    return addressString
}